/**
 * CL-TRADES-SUPPLIER-COLLAB-001A — Staff global Companies & Suppliers directory access.
 */

import { readCanManageTradeDirectory } from "./staffCapabilitiesModel";

function safeStr(value) {
  return String(value ?? "").trim();
}

function isAdminRole(profile = null) {
  return safeStr(profile?.role).toLowerCase() === "admin";
}

export function resolveStaffTradeDirectoryAccess({
  isAdmin = false,
  userProfile = null,
} = {}) {
  const admin = isAdmin === true || isAdminRole(userProfile);
  const canManageTradeDirectory = admin || readCanManageTradeDirectory(userProfile);
  return {
    isAdmin: admin,
    canManageTradeDirectory,
    canAccessCompaniesDirectory: canManageTradeDirectory,
  };
}

export const STAFF_COMPANIES_DIRECTORY_ROUTE = "/client-portal/companies-suppliers";

export function shouldShowStaffCompaniesDirectoryNav(access = {}) {
  return access?.canAccessCompaniesDirectory === true;
}

export function buildStaffCompaniesDirectoryNavItem(access = {}) {
  if (!shouldShowStaffCompaniesDirectoryNav(access)) return null;
  return {
    to: STAFF_COMPANIES_DIRECTORY_ROUTE,
    label: "Companies & Suppliers",
    end: true,
  };
}
